// extracted by mini-css-extract-plugin
module.exports = {"content":"SaleOfferDetailsButtons_content__LcgT1","button":"SaleOfferDetailsButtons_button__lYl50"};